import { useFormContext } from "react-hook-form";
import { ErrorMessages } from "../../../../components/errorMessages/errorMessages";

export const InputEmail = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className="form-field mt-4">
      <label htmlFor="email">Email</label>
      <input
        type="email"
        aria-invalid={errors?.email ? "true" : "false"}
        name="email"
        {...register("email", {
          required: "Email is required",
          pattern: {
            value: /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/,
            message: "Invalid email address",
          },
        })}
        placeholder="Email"
      />
      <ErrorMessages errors={errors?.email?.message} />
    </div>
  );
};
